module.exports = __webpack_public_path__ + "img/item2_2.ed5207ce.png";